import { FC, useEffect, useState } from 'react';
import { useMediaQuery } from 'react-responsive';

import 'react-multi-carousel/lib/styles.css';
import { OFICINA } from '../config/constants';
import { Box, Box2, TextSplit } from '../styled/intro';
import { useAppDispatch, useAppSelector } from '../stores/store';

const Intro: FC = () => {
  const [isBackgroundVisible, setIsBackgroundVisible] = useState(true);
  const [isVisible, setIsVisible] = useState(false);

  const [sizeBox, setSizeBox] = useState<number>(75);
  const [titleButtom, setTitleButtom] = useState<number>(255);
  const [sizeTitle, setSizeTitle] = useState<number>(25);
  const isMobile = useMediaQuery({ query: '(max-width: 768px)' });
  const isTablet = useMediaQuery({ query: '(min-width: 769px) and (max-width: 1024px)' });
  const isDesktop = useMediaQuery({ query: '(min-width: 1025px)' });
  const [posBox, setPosBox] = useState<number>(1.43);

  useEffect(() => {
    if (isMobile) {
      setSizeBox(30);
      setPosBox(0.858);
      setTitleButtom(45);
      setSizeTitle(18);
    } else if (isTablet) {
      setSizeBox(50);
      // setPosBox(0.953333333);
      setPosBox(1.953333333);
      setTitleButtom(45);
      setSizeTitle(55);
    } else {
      setSizeBox(75);
      setPosBox(1.43);
      setTitleButtom(255);
      setSizeTitle(80);
    }
  }, [isMobile, isTablet, isDesktop]);

  // Después de 2 segundos, cambia el estado para activar la transición
  useEffect(() => {
    setIsVisible(true);
    const timer = setTimeout(() => {
      setIsBackgroundVisible(false);
    },isMobile? 4000: 3000); // 2 segundos

    // Limpiar el timer en caso de que el componente se desmonte
    return () => clearTimeout(timer);
  }, []);

  const finallyProps = useAppSelector<boolean>(state => state.shared.finallyProps);

  return (
    <section
      className={`video-container-intro main embed-responsive embed-responsive-16by9 video-height background-visible`}
    >
      <TextSplit
        $size={sizeTitle}
        $bottom={titleButtom}
        className={`animated-text ${isVisible ? 'slide-in' : ''} ${!isBackgroundVisible ? 'iframe-hidden' : 'iframe-visible'}`}
      >
        LÍDER MUNDIAL EN SERVICIOS INMOBILIARIOS
      </TextSplit>
      <div className="overlay-intro"></div>
      {finallyProps && (
        <>
          <iframe
            className={`iframe-intro ${isBackgroundVisible ? 'iframe-hidden' : 'iframe-visible'}`}
            src="https://www.youtube.com/embed/0tFNddofkwc?autoplay=1&loop=1&mute=1&playlist=0tFNddofkwc&modestbranding=1&showinfo=0&controls=0&rel=0&disablekb=1&fs=0&iv_load_policy=3"
            title={OFICINA}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
          <Box $alpha={0.6} $col={1} $row={posBox + 3} $size={sizeBox} />
          <Box $alpha={0.6} $col={2} $row={posBox + 2} $size={sizeBox} />
          <Box $alpha={0.8} $col={1} $row={posBox + 2} $size={sizeBox} />
          <Box $alpha={0.6} $col={5} $row={posBox + 1} $size={sizeBox} />
          <Box $alpha={0.6} $col={4} $row={posBox + 1} $size={sizeBox} />
          <Box $alpha={0.85} $col={3} $row={posBox + 1} $size={sizeBox} />
          <Box $alpha={1} $col={2} $row={posBox + 1} $size={sizeBox} />
          <Box $alpha={1} $col={1} $row={posBox + 1} $size={sizeBox} />
          <Box $alpha={0.6} $col={6} $row={posBox} $size={sizeBox} />
          <Box $alpha={0.85} $col={5} $row={posBox} $size={sizeBox} />
          <Box $alpha={1} $col={4} $row={posBox} $size={sizeBox} />
          <Box $alpha={1} $col={3} $row={posBox} $size={sizeBox} />
          <Box $alpha={1} $col={2} $row={posBox} $size={sizeBox} />
          <Box $alpha={1} $col={1} $row={posBox} $size={sizeBox} />
        </>
      )}
    </section>
  );
};
export default Intro;
